import './LanguageSelector.component.scss';

import React, { useEffect, useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { languages } from '../../../assets/i18n/languages.index';
import { TLanguages } from '../../../domain/language.interface';
import { changeLocale } from '../../../store/language-provider/language-provider.actions';
import { makeSelectLocale } from '../../../store/language-provider/language-provider.selectors';
import { getAssetUrl } from '../../../utils/GetAssetUrl';

export function LanguageSelectorComponent(props: any) {
  const dispatch = useDispatch();
  const locale: TLanguages = useSelector(makeSelectLocale());
  const [selectedLanguage, setSelectedLanguage] = useState(locale);
  const [toggle, setToggle] = useState(false);

  useEffect(() => {
    setSelectedLanguage(locale);
  }, [locale]);

  function handleOnChangeLanguage(language: TLanguages) {
    if (language === selectedLanguage) {
      setToggle(!toggle);
      return;
    }
    dispatch(changeLocale(language));
  }

  return (
    <div className='language-selector'>
      <div
        className='button-selector'
        onClick={() => setToggle(!toggle)}
        style={{
          backgroundImage: `url(${getAssetUrl.icons(
            `${selectedLanguage}.svg`,
          )})`,
        }}
      />
      <Dropdown show={toggle}>
        <Dropdown.Menu>
          <Dropdown.Header>
            <FormattedMessage id='language.header' />
          </Dropdown.Header>
          {languages.map((language: TLanguages, id: number) => (
            <Dropdown.Item
              onClick={() => handleOnChangeLanguage(language)}
              eventKey={`${id}`}
              key={id}
            >
              <div
                className='flag-container'
                style={{
                  backgroundImage: `url(${getAssetUrl.icons(
                    `${language}.svg`,
                  )})`,
                }}
              ></div>
              <div className='text-container'>
                <FormattedMessage id={`language.${language}`} />
              </div>
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}
